export const FORMAT_DATE_TIME = 'DD/MM/YYYY';
export const FORMAT_DATE_TIME_I = 'DD/MM/YYYY A';
export const FORMAT_DATE_TIME_II = 'DD MMM YYYY HH:mm';
export const FORMAT_DATE_TIME_III = 'DD/MM/YYYY HH:mm';
export const FORMAT_DATE_TIME_IV = 'DD MMM YYYY hh:mm A';
export const FORMAT_DATE_TIME_V = 'DD-MM-YYYY';
export const FORMAT_DATE_TIME_VI = 'YYYY-MM-DD';
export const DATA_PER_PAGE = 20;

// Keep in sync with BE AllowedTablePageSizes (0 = unset)
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];

export const SERVICE_FEE_TYPE = [
  {
    value: 1,
    label: 'Percentage'
  },
  {
    value: 2,
    label: 'Number'
  }
];

export const PLATFORM_FEE_TYPE = [
  {
    value: 1,
    label: 'Percentage'
  },
  {
    value: 2,
    label: 'Number'
  }
];

export const PAYMENT_POINT = [
  {
    label: 'Company',
    value: 'C'
  },
  {
    label: 'Driver/Fleet',
    value: 'DF'
  }
];

export const PAYMENT_POINT_FLEET = [
  {
    label: 'Fleet',
    value: 'F'
  },
  {
    label: 'Driver',
    value: 'D'
  },
  {
    label: 'Company',
    value: 'C'
  }
];

export const PAYMENT_METHOD_TYPE = [
  {
    label: 'Card Present',
    value: 'card_present'
  },
  {
    label: 'Card',
    value: 'card'
  }
];

export const CARD_TYPE = [
  {
    label: 'American Express',
    value: 'amex'
  },
  {
    label: 'Mastercard',
    value: 'mastercard'
  },
  {
    label: 'Visa',
    value: 'visa'
  },
  {
    label: 'eftpos Australia',
    value: 'eftpos_au'
  },
  {
    label: 'China UnionPay',
    value: 'unionpay'
  },
  {
    label: 'Japan Credit Bureau',
    value: 'jcb'
  },
  {
    label: 'Diners Club',
    value: 'diners'
  },
  {
    label: 'Discover',
    value: 'discover'
  }
];

export const PAYOUT_STATUS = [
  {
    label: 'Group Unpaid',
    value: 'group'
  },
  {
    label: 'Endpoint Unpaid',
    value: 'endpoint'
  }
];

export const FILTER_NUMBER_OPTIONS = [
  {
    label: 'is equal to',
    value: 'equal'
  },
  {
    label: 'is between',
    value: 'between'
  },
  {
    label: 'is greater than',
    value: 'min'
  },
  {
    label: 'is less than',
    value: 'max'
  }
];

export const TABLE_COLUMN_FILTER_KEY = {
  FLEET: 'fleetSettings',
  GROUP: 'groupSettings',
  DRIVER: 'driverSettings',
  COMPANY: 'companySettings',
  TRANSACTION: 'transactionSettings',
  SUBSIDY_TRANSACTION: 'subsidyTransactionSettings'
};

export const LIST_REFUND_OPTIONS = isPartialRefund => [
  {
    value: 'full-refund',
    label: 'Full Refund'
  },
  {
    value: 'partial-refund',
    label: 'Partial  Refund'
  },
  ...(isPartialRefund
    ? [
        {
          value: 'cancel',
          label: 'Cancel'
        }
      ]
    : [])
];

export const DUPLICATE_EMAIL = 'DUPLICATE EMAIL';

export const userBasicStatusConfig = {
  0: {
    label: 'Inactive',
    type: 'danger',
    icon: 'ban'
  },
  1: {
    label: 'Active',
    type: 'success',
    icon: 'check'
  }
};

// USER_STATUS_LOCKED names the status userStatusConfig labels "Locked", so code
// branching on it does not carry a bare 2. It mirrors enum.UserLocked on the API.
export const USER_STATUS_LOCKED = 2;

export const userStatusConfig = {
  ...userBasicStatusConfig,
  [USER_STATUS_LOCKED]: {
    label: 'Locked',
    type: 'warning',
    icon: 'lock'
  },
  3: {
    label: 'Archived',
    type: 'secondary',
    icon: 'folder-plus'
  },
  4: {
    label: 'Guest',
    type: 'primary',
    icon: 'user'
  }
};

export const DRIVER = 'DRIVER';
export const GROUP = 'GROUP';
export const COMPANY = 'COMPANY';
export const FLEET = 'FLEET';

export const USER_STATUS_OPTIONS = Object.entries(userStatusConfig).map(([value, { label }]) => ({
  value: Number(value),
  label
}));

export const STRIPE_CONNECT_OPTIONS = [
  { value: 1, label: 'Yes' },
  { value: 0, label: 'No' }
];

// FRAUD_CHECK_OPTIONS mirrors enum.FraudCheck on the API; the labels match the
// driver list's Fraud Check badge.
export const FRAUD_CHECK_OPTIONS = [
  { value: 'not_locked', label: 'OK' },
  { value: 'velocity_locked', label: 'Locked by fraud check' },
  { value: 'manually_locked', label: 'Locked by admin' }
];

// TRANSACTION_STATUS_OPTIONS mirrors enum.TransactionStatus on the API, which
// both transactions.transaction_status and stripe_infos.stripe_status hold.
export const TRANSACTION_STATUS_OPTIONS = [
  { value: 'succeeded', label: 'Succeeded' },
  { value: 'incomplete', label: 'Incomplete' },
  { value: 'failed', label: 'Failed' },
  { value: 'refunded', label: 'Refunded' },
  { value: 'refund-pending', label: 'Refund Pending' },
  { value: 'refund-partial', label: 'Partial Refund' },
  { value: 'refund-collected', label: 'Refund Collected' }
];

// Card-origin pricing only applies to Australian groups on destination
// charges (model.CardOriginPricingEligible on the API).
export const CARD_ORIGIN_COUNTRY_CODE = 'AU';
export const CARD_ORIGIN_CHARGE_TYPE_CODE = 'destination-charge';
